module.exports = __webpack_public_path__ + "fonts/95d2d2d.woff";